export interface ModulePermission {
  moduleId: number;
  modules: string;
  isAll: boolean;
  isView: boolean;
  isAdd: boolean;
  isEdit: boolean;
  isDelete: boolean;
  isActivate: boolean;
}

export interface PermissionResponse {
  status: boolean;
  message: string;
  data: ModulePermission[];
  totalRecords: number;
  recordsFiltered: number;
}

export interface NavItemConfig {
  route: string;
  icon: string;
  label?: string; // Optional: custom label (defaults to module name)
  children?: NavItemConfig[];
}

// Module name to navigation configuration mapping
export const MODULE_NAV_CONFIG: { [key: string]: NavItemConfig } = {
  'Manage Clinics': { route: '/clinics', icon: 'local_hospital' },
  'Manage Codes': { route: '/codes', icon: 'list_alt' },
  'Global Claim Form Rules': { route: '/claim-form-rules', icon: 'verified_user' },
  'Payer & Claim Type Rules': { route: '/payer-rules', icon: 'policy' },
  'Manage Staff Users': { route: '/staff-users', icon: 'manage_accounts' },
  'Manage Providers': { route: '/providers', icon: 'medical_services' },
  'Manage Patients': { route: '/patients', icon: 'personal_injury' },
  'Documents Configuration': { route: '/documents', icon: 'folder_special' },
  'OCR & AI Settings': { route: '/ocr-settings', icon: 'language' },
  'Manage Claims': { route: '/claims', icon: 'verified_user' },
  'Claim Form Templates': { route: '/claim-form-templates', icon: 'text_snippet' },
  'Audit Logs': { route: '/audit-logs', icon: 'article' },
  'Reports': { 
    route: '/reports', 
    icon: 'assessment',
    children: [
      // { route: '/reports/documents', icon: 'description', label: 'Documents Reports' },
      { route: '/reports/claims', icon: 'assessment', label: 'Claim Reports' },
      { route: '/reports/split-claims', icon: 'assessment', label: 'Split Claim Reports' },
      // { route: '/reports/payers', icon: 'business', label: 'Payer Reports' },
      { route: '/reports/financial', icon: 'trending_up', label: 'Financial Reports' },
      // { route: '/reports/ai-performance', icon: 'analytics', label: 'AI Performance Reports' },
      { route: '/reports/token-reports', icon: 'assessment', label: 'Token Reports' }
    ]
  }
};

// Route to module name mapping
// NOTE: The guard walks up parent paths automatically, but explicit entries here
// ensure correct resolution for deeply-nested or detail routes.
export const ROUTE_MODULES: { [key: string]: string } = {
  // Manage Clinics
  '/clinics': 'Manage Clinics',
  '/clinics/add': 'Manage Clinics',
  '/clinics/edit': 'Manage Clinics',

  // Manage Codes
  '/codes': 'Manage Codes',

  // Global Claim Form Rules
  '/claim-form-rules': 'Global Claim Form Rules',

  // Payer & Claim Type Rules
  '/payer-rules': 'Payer & Claim Type Rules',
  '/payer-rules/add': 'Payer & Claim Type Rules',
  '/payer-rules/edit': 'Payer & Claim Type Rules',
  '/payer-rules/view': 'Payer & Claim Type Rules',

  // Manage Staff Users
  '/staff-users': 'Manage Staff Users',
  '/staff-users/add': 'Manage Staff Users',
  '/staff-users/edit': 'Manage Staff Users',

  // Manage Providers
  '/providers': 'Manage Providers',
  '/providers/add': 'Manage Providers',
  '/providers/edit': 'Manage Providers',

  // Manage Patients
  '/patients': 'Manage Patients',
  '/patients/add': 'Manage Patients',
  '/patients/edit': 'Manage Patients',

  // Documents Configuration
  '/documents': 'Documents Configuration',

  // OCR & AI Settings
  '/ocr-settings': 'OCR & AI Settings',

  // Manage Claims
  '/claims': 'Manage Claims',

  // Claim Form Templates
  '/claim-form-templates': 'Claim Form Templates',
  '/claim-form-templates/add': 'Claim Form Templates',
  '/claim-form-templates/edit': 'Claim Form Templates',
  '/claim-form-templates/view': 'Claim Form Templates',

  // Audit Logs
  '/audit-logs': 'Audit Logs',

  // Reports (all sub-routes map to the same Reports module)
  '/reports': 'Reports',
  '/reports/documents': 'Reports',
  '/reports/claims': 'Reports',
  '/reports/claims/details': 'Reports',
  '/reports/split-claims': 'Reports',
  '/reports/payers': 'Reports',
  '/reports/financial': 'Reports',
  '/reports/financial/details': 'Reports',
  '/reports/ai-performance': 'Reports',
  '/reports/token-reports': 'Reports',
};
